import React from 'react'

// interfaces
import { TAllergies } from '../../helpers/interfaces';
import { createCssClass } from '../../helpers/common';

import { IoFishSharp } from "react-icons/io5";
import { GiCrabClaw, GiGrainBundle, GiSpiralShell,GiPeanut } from "react-icons/gi";
import { LuCherry, LuEgg, LuMilk, LuBean } from "react-icons/lu";
import { TbSeeding } from "react-icons/tb";

// const allergiesCollection: TAllergies[] = ['arachidi', 'cereali', 'crostacei', 'frutta', 'frutta secca', 'latte', 'molluschi', 'lupini', 'uova', 'pesce', 'soia', 'sedano', 'senape', 'sesamo'];

const allergiesCollection: { name: TAllergies, icon: React.ReactNode }[] = [
  { name: 'arachidi', icon: <GiPeanut /> },
  { name: 'cereali', icon: <GiGrainBundle /> },
  { name: 'crostacei', icon: <GiCrabClaw /> },
  { name: 'frutta', icon: <LuCherry /> },
  { name: 'frutta secca', icon: <GiPeanut /> },
  { name: 'latte', icon: <LuMilk /> },
  { name: 'molluschi', icon: <GiSpiralShell  /> },
  { name: 'lupini', icon: <LuBean /> },
  { name: 'uova', icon: <LuEgg /> },
  { name: 'pesce', icon: <IoFishSharp /> },
  { name: 'soia', icon: <TbSeeding /> },
  { name: 'sedano', icon: <TbSeeding /> },
  { name: 'senape', icon: <GiGrainBundle /> },
  { name: 'sesamo', icon: <GiGrainBundle /> },
]

interface Props {
  values: TAllergies[];
  setAllergies: (allergies: TAllergies[]) => void;
  className?: string;
  label?: string;
  required?: boolean;
}
const Allergies: React.FC<Props> = ({ values, setAllergies, className, label = 'Allergie', required = false }) => {

  const [isActive, setIsActive] = React.useState(!!values.length);

  const handleAllergies = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, allergy: TAllergies) => {
    e.preventDefault();
    if (!values) return setAllergies([allergy]);
    if (values.includes(allergy)) {
      setAllergies(values.filter((item) => item !== allergy));
    } else {
      setAllergies([...values, allergy]);
    }
  }

  return (
    <div className={createCssClass(['allergies', className])}>
      <div className="label">{label}
        {/* {!required && <span className='optional'> (opzionale)</span>} */}
      </div>

      <button name="allergies"
        className={createCssClass(['button', 'select-allergies'])}
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          e.preventDefault();

          setIsActive(prevValue => {
            // if (prevValue === true && !!values?.length) setAllergies([]);
            // if (prevValue === true && !!values.length) setAllergies([]);
            // if (!!values.length) setAllergies([]);

            if (prevValue === true) setAllergies([]);
            return !prevValue;
          });

        }}
      >{!!values.length ? 'Cancella allergie selezionate' : 'Cliccare qui se sono presenti persone allergiche'}
      </button>


      {isActive && <p>Indicare quali allergie sono presenti.</p>}

      <div className="flexwrapper">
        {isActive && allergiesCollection.map((allergy, index) => (
          <button name={allergy.name}
            key={index}
            className={values && values.includes(allergy.name) ? 'button selected' : 'button'}
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAllergies(e, allergy.name)}
          >
            <span className='allergy-icon'>{allergy.icon}</span> <span className='allergy-name'>{allergy.name}</span> 
          </button>
        ))}
      </div>

      {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
    </div>
  )
}
export default Allergies;